
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["feather feather-repeat",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","class":"feather feather-repeat"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 1l4 4-4 4"}}),_c('path',{attrs:{"d":"M3 11V9a4 4 0 014-4h14M7 23l-4-4 4-4"}}),_c('path',{attrs:{"d":"M21 13v2a4 4 0 01-4 4H3"}})])
          )
        }
      }
    